// extracted by mini-css-extract-plugin
export default {"viewButton":"WidgetViewButton_viewButton__8Wgng"};